<template>
  <div class="search-result-container" v-if="searchResultList.length">
    <div class="test">
      <!-- for in searchResultList -->
      <div class="content-header-container" v-if="filteredArray1.length > 0">
        <div class="header-title-container yg-jalnan">
          <p class="content-title">국내 여행</p>
          <p class="content-subtitle indent"></p>
        </div>
        <div class="header-title-more">
          <p class="content-title-more s-core-dream-regular">더보기</p>
        </div>
      </div>

      <div class="box-container" v-if="filteredArray1.length > 0">
        <div class="box-item" v-for="item in filteredArray1">
          <img :src="item.thumbnail" v-if="item.category === '1'" />
          <p v-if="item.category === '1'">{{ item.contents }}</p>
        </div>
      </div>

      <div class="content-header-container" v-if="filteredArray2.length > 0">
        <div class="header-title-container yg-jalnan">
          <p class="content-title">여행</p>
          <p class="content-subtitle indent">매거진</p>
        </div>
        <div class="header-title-more">
          <p class="content-title-more s-core-dream-regular">더보기</p>
        </div>
      </div>

      <div class="box-container" v-if="filteredArray2.length > 0">
        <div class="box-item" v-for="item in filteredArray2">
          <img :src="item.thumbnail" v-if="item.category === '2'" />
          <p class="center" v-if="item.category === '2'">{{ item.contents }}</p>
        </div>
      </div>
    </div>

    <div class="footer">
      <v-btn
        class="footer-fab"
        elevation="5"
        fab
        @click.prevent="emptySearchResultList"
        icon
      >
        <v-icon> mdi-keyboard-backspace </v-icon></v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filteredArray1: [],
      filteredArray2: [],
    };
  },
  props: ["searchResultList"],
  watch: {
    searchResultList: {
      deep: true,
      handler(newData) {
        if (Array.isArray(newData)) {
          this.filteredArray1 = newData.filter((item) => item.category === "1"); // those are freaking anti pattern!
          this.filteredArray2 = newData.filter((item) => item.category === "2"); // those are freaking anti pattern!

          console.log("this.filteredArray1=--==--");
          console.log(this.filteredArray1);
          console.log("this.filteredArray2=--==--");
          console.log(this.filteredArray2);
        }
      },
    },
  },
  methods: {
    emptySearchResultList() {
      // Child -> Parent : searchResultList 지우기
      this.$emit("emptySearchResultList");
    },
  },
};
</script>

<style scoped>
.search-result-container {
  margin-bottom: 200px;
}

.content-header-container {
  display: flex;
  justify-content: space-between;
  height: 35px;
  margin-bottom: 10px;
}

.header-title-container {
  display: flex;
}

.content-title {
  font-size: 24px;
}

.content-subtitle {
  color: #f9730c;
  font-size: 24px;
}

p.indent {
  padding-left: 0.4em;
}

.content-title-more {
  color: grey;
  margin-top: 8px;
}

.box-container {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.box-item {
  width: 120px;
  height: 178px;
  margin-left: 2px;
  margin-right: 2px;
  margin-bottom: 40px;
}

@media (max-width: 390px) {
  .box-item {
    width: 112px;
    height: 158px;
    margin-left: 2px;
    margin-right: 2px;
    margin-bottom: 40px;
  }
}

.center {
  margin-top: 6px;
  text-align: center;
}

img {
  border-radius: 5px;
  height: 100%;
}

.outer {
  display: flex;
  flex: 1;
  width: auto;
  height: 100%;
  justify-content: center;
}

.inner-content {
  width: 50px;
  justify-content: center;
  align-items: center;
}

.inner-content:not(:first-of-type) {
  margin-left: 10px;
}

.content-desc {
  margin-top: 12.5px; /* workaround, could be anti-pattern, i guess */
  overflow: hidden;
  text-overflow: ellipsis;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}

.footer-fab {
  position: fixed;
  right: 15px;
  bottom: 15px;
}
</style>
